// Utilities
import Log from '~/_Utility/Log';

// Core
import Favorite from '~/Favorite';
import History from '~/History';
import InstantSearch from '~/InstantSearch';
import Interest from '~/Interest';
import TextToggle from '~/TextToggle';
import Notice from '~/Notice';

// Vendors
import Bootstrap from './_Vendor/Bootstrap';
import Masonry from './_Vendor/Masonry';
import WooCommerce from './_Vendor/WooCommerce';
import TEC from './_Vendor/TEC';

// Styles
import '|/../scss/app.scss';
import '|/app.styl';

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Let the frontend know we are cooking
        new Log('Phase Three is ready.', 'success');

        // Core initialization
        new Favorite();
        new History();
        new InstantSearch();
        new Interest();
        new TextToggle();
        new Notice();

        // Vendors initialization
        new Bootstrap();
        new Masonry();
        new WooCommerce();
        new TEC();

    });

})(jQuery);
